import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'issue-create.common.fields.description-field.placeholder',
		defaultMessage:
			'Paste a Confluence link here, and we can help generate the description from the page’s contents.',
		description:
			'Placeholder text for description field when proactive work description completer enabled',
	},
});
